/**
 * Normaliza uma URL adicionando https:// se não tiver protocolo
 * @param url - URL para normalizar
 * @returns URL normalizada com protocolo
 */
export const normalizeUrl = (url: string): string => {
  if (!url || url.trim() === '') {
    return '';
  }
  
  const trimmedUrl = url.trim();
  
  // Se já tem protocolo (http:// ou https://), retorna como está
  if (/^https?:\/\//i.test(trimmedUrl)) {
    return trimmedUrl;
  }
  
  // Se começa com //, adiciona https:
  if (trimmedUrl.startsWith('//')) {
    return `https:${trimmedUrl}`;
  }
  
  // Caso contrário, adiciona https://
  return `https://${trimmedUrl}`;
};

/**
 * Valida se uma string é uma URL válida (com ou sem protocolo)
 * @param url - URL para validar
 * @returns true se for uma URL válida
 */
export const isValidUrl = (url: string): boolean => {
  if (!url || url.trim() === '') {
    return false;
  }
  
  try {
    const normalizedUrl = normalizeUrl(url);
    const urlObj = new URL(normalizedUrl);
    
    // Verificar se tem um hostname válido
    return urlObj.hostname.length > 0 && urlObj.hostname.includes('.');
  } catch {
    return false;
  }
};
